import axiosInstance from "../../../utils/axios";
import { ROLE } from "../../../utils/Constants";

const options = { role: ROLE.SUPER_ADMIN };

const path = "admin/transactions";

export const getTransactionsList = async (page = 1, limit = 10, search = "", status = "", clubType = "") => {
  let url = `${path}/list?page=${page}&limit=${limit}`;
  if (search) {
    url += `&search=${encodeURIComponent(search)}`;
  }
  if (status && status !== "all") {
    url += `&status=${encodeURIComponent(status)}`;
  }
  if (clubType && clubType !== "all") {
    url += `&clubType=${encodeURIComponent(clubType)}`;
  }
  return await axiosInstance(options).get(url);
};

export const deleteTransaction = async (id) => {
  return await axiosInstance(options).delete(`${path}/${id}`);
};

export const bulkDeleteTransactions = async (values) => {
  return await axiosInstance(options).post(`${path}/bulk-delete`, values);
};



